import type { RootState } from 'src/store';
import { connect } from 'react-redux';

import { getSceneDefiningBackgroundId, isEditingGarmentMarkers } from 'src/selectors/layers';
import { getDecorationSpecs } from 'src/selectors/pages/editor';
import { toggleGarmentMarkersEditing } from '../slice';
import garmentMarkersToggle from './garmentMarkersToggle';

const mapStateToProps = (state: RootState) => {
    const backgroundId = getSceneDefiningBackgroundId(state);
    const { decorationPlacement } = getDecorationSpecs(state);

    let disabledReason: string | undefined;
    if (!backgroundId) {
        disabledReason = 'Upload a background to show garment markers on.';
    } else if (!decorationPlacement || decorationPlacement.length === 0) {
        // Gate on decorationPlacement presence: calibrating garment markers on a product without
        // decoration placement data (such as non-apparel) serves no function.
        disabledReason = 'No apparel decoration-placement data is available for this product.';
    }

    return {
        isEditing: isEditingGarmentMarkers(state),
        disabled: !!disabledReason,
        disabledReason,
    };
};

const garmentMarkersToggleContainer = connect(mapStateToProps, { onToggle: toggleGarmentMarkersEditing })(
    garmentMarkersToggle,
);

export default garmentMarkersToggleContainer;
